import { render, staticRenderFns } from "./GroupMenu.vue?vue&type=template&id=255a5e07&scoped=true&"
import script from "./GroupMenu.vue?vue&type=script&lang=ts&"
export * from "./GroupMenu.vue?vue&type=script&lang=ts&"
import style0 from "./GroupMenu.vue?vue&type=style&index=0&id=255a5e07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255a5e07",
  null
  
)

export default component.exports